import { ComponentProps, PropsWithChildren } from 'react';

import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib';

const typographyVariants = cva('text-base font-medium leading-5', {
  variants: {
    variant: {
      '16-m': '',
      '16-m-caps': 'uppercase tracking-[0.3px] font-medium',
      '16-r': 'font-normal',
      '14-m': 'text-sm font-medium',
      '14-r': 'text-sm font-normal',
      '13-r': 'text-[13px] font-normal tracking-[0.2px]',
      '12-r': 'text-[12px] font-normal',
      '10-r': 'text-[10px] font-normal',
    },

    color: {
      default: 'text-base-500',
      'text-base-100': 'text-base-100',
      'brand-500': 'text-brand-500',
      'base-300': 'text-base-300',
      'negative-500': 'text-negative-500',
      'contrast-500': 'text-contrast-500',
    },
  },
  defaultVariants: {
    variant: '16-m',
  },
});

export interface ITypographyProps
  extends Omit<ComponentProps<'p'>, 'color'>,
    PropsWithChildren,
    VariantProps<typeof typographyVariants> {}

export const Typography = ({
  className,
  children,
  variant,
  color,
  ...props
}: ITypographyProps) => {
  return (
    <p
      className={cn(typographyVariants({ variant, color }), className)}
      {...props}
    >
      {children}
    </p>
  );
};
